import React from 'react';
import {ZNO_MONTH, ZNO_DAY} from "../../constants/settings";

export default class DaysLeft extends React.Component {
    getDiff() {
        const now = new Date();
        let year = now.getFullYear();
        let znoDate = new Date(year + '-' + ZNO_MONTH + '-' + ZNO_DAY);
        let diff = this.getTwoDatesDiff(znoDate, now);
        if (diff <= 0) {
            if (now.getMonth() < 8) {
                return null;
            }
            year++;
            znoDate = new Date(year + '-' + ZNO_MONTH + '-' + ZNO_DAY);
            diff = this.getTwoDatesDiff(znoDate, now);
        }

        return diff;
    }

    getTwoDatesDiff(firstDate, secondDate) {
        return Math.floor((firstDate.getTime() - secondDate.getTime()) / 86400000);
    }

    render() {
        const diff = this.getDiff();
        if (diff <= 0) {
            return null
        }

        let daysText = '';

        if (diff > 10 && diff < 20) {
            daysText = 'днів';
        } else {
            switch (diff % 10) {
                case 1:
                    daysText = 'день';
                    break;
                case 2:
                case 3:
                case 4:
                    daysText = 'дні';
                    break;
                default:
                    daysText = 'днів';
                    break;
            }
        }

        return (
            <p className="p-heading p-large">
                До тестування залишилось <span className="days-left">{diff}</span> {daysText}
            </p>
        );
    }
}